import React, { Component, useState } from "react";
import { useContext } from "react";
import { BsFillHeartFill } from "react-icons/bs";
import Slider from "react-slick";
import axios from "axios";

import {
  Accordion,
  Table,
  Carousel,
  Badge,
  Form,
  Nav,
  Button,
  Row,
  Col,
  Stack,
} from "react-bootstrap";
import { Link } from "react-router-dom";

import CartContext from "./CartContext";

export class Pricing extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      productType: "",
      products: [],
      selectedProduct: "",
    };
  }
  InitProducts = () => {
    var prods = [
      {
        productType: this.context.ProductType.Retail_POS,
        License: [
          // {
          //   LicenseType: "FREE",
          //   Description: "Basic",
          //   Supported: {
          //     Features: [
          //       { value: "Admin/POS User Access = 1" },
          //       { value: "Transaction Data Retention = 7 Days" },
          //       { value: "Cloud Hosting Plan = Basic " },
          //       { value: "Point Of Sale(POS) Portal" },
          //       { value: "Admin Portal" },
          //       { value: "Product Inventory Management" },
          //       { value: "In-Store, Take Away, Delivery Orders" },
          //       { value: "Single-POS Sessions" },
          //       { value: "Barcode Generator" },
          //       { value: "Any Device & OS Friendly" },
          //       { value: "Keyboard and Touch Friendly" },
          //       { value: "Fuzzy Product Search" },
          //       { value: "AI Voice Recognition Product Search" },
          //       { value: "Email based OTP Authentication" },
          //       { value: "Basic reports" },
          //     ],
          //   },
          //   UnSupported: {
          //     Features: [
          //       { value: "Orders & Delivery Management" },
          //       { value: "Supplier Management" },
          //       { value: "Purchase Management" },
          //       { value: "Customer Relationship Management(CRM)" },
          //       { value: "Coupons Management" },
          //       { value: "Employees/Human Resource Management (HRM)" },
          //       { value: "Accounts Management" },
          //       { value: "Busienss Insights & Analytics" },
          //       { value: "Users & Roles Management" },
          //     ],
          //   },
          // },
          {
            LicenseType: "STANDARD",
            Description: "Starter!",
            Supported: {
              Features: [
                { value: "Admin/POS User Access = 1" },
                { value: "Transaction Data Retention = 1 Year" },
                { value: "Cloud Hosting Plan = Standard" },
                { value: "Point Of Sale(POS) Portal" },
                { value: "Admin Portal" },
                { value: "Product Inventory Management" },
                { value: "In-Store, Take Away, Delivery Orders" },
                { value: "Multi-POS Sessions" },
                { value: "Barcode Generator" },
                { value: "Any Device & OS Friendly" },
                { value: "Keyboard and Touch Friendly" },
                { value: "Fuzzy Product Search" },
                { value: "AI Voice Recognition Product Search" },
                { value: "Email based OTP Authentication" },
                { value: "Advanced reports" },
                { value: "Orders & Delivery Management" },
                { value: "Supplier Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice",
            Supported: {
              Features: [
                { value: "Admin/POS User Access = 3" },
                { value: "Transaction Data Retention = 2 Years" },
                { value: "Cloud Hosting Plan = Professional" },
                { value: "Point Of Sale(POS) Portal" },
                { value: "Admin Portal" },
                { value: "Product Inventory Management" },
                { value: "In-Store, Take Away, Delivery Orders" },
                { value: "Multi-POS Sessions" },
                { value: "Barcode Generator" },
                { value: "Any Device & OS Friendly" },
                { value: "Keyboard and Touch Friendly" },
                { value: "Fuzzy Product Search" },
                { value: "AI Voice Recognition Product Search" },
                { value: "Email based OTP Authentication" },
                { value: "Advanced reports" },
                { value: "Orders & Delivery Management" },
                { value: "Supplier Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",
            Supported: {
              Features: [
                { value: "Admin/POS User Access = 5" },
                { value: "Transaction Data Retention = 3 Years" },
                { value: "Cloud Hosting Plan = Premium" },
                { value: "Point Of Sale(POS) Portal" },
                { value: "Admin Portal" },
                { value: "Product Inventory Management" },
                { value: "In-Store, Take Away, Delivery Orders" },
                { value: "Multi-POS Sessions" },
                { value: "Barcode Generator" },
                { value: "Any Device & OS Friendly" },
                { value: "Keyboard and Touch Friendly" },
                { value: "Fuzzy Product Search" },
                { value: "AI Voice Recognition Product Search" },
                { value: "Email based OTP Authentication" },
                { value: "Advanced reports" },
                { value: "Orders Management" },
                { value: "Supplier Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
      {
        productType: this.context.ProductType.Restaurant_POS,
        License: [
          // {
          //   LicenseType: "FREE",
          //   Description: "Basic",
          //   Supported: {
          //     Features: [
          //       { value: "Admin/POS User Access = 1" },
          //       { value: "Transaction Data Retention = 7 Days" },
          //       { value: "Cloud Hosting Plan = Basic " },
          //       { value: "Point Of Sale(POS) Portal" },
          //       { value: "Admin Portal" },
          //       { value: "Captain App / Tables Management" },
          //       { value: "Kitchen Display System(KDS)" },
          //       { value: "Inventory Management" },
          //       { value: "Dine-In Orders Management" },
          //       { value: "Single-POS Sessions" },
          //       { value: "Barcode Generator" },
          //       { value: "Fuzzy Product Search" },
          //       { value: "AI Voice Recognition Product Search" },
          //       { value: "Email based OTP Authentication" },
          //       { value: "Keyboad & Touch friendly" },
          //       { value: "Basic reports" },
          //     ],
          //   },
          //   UnSupported: {
          //     Features: [
          //       { value: "Receipe Management" },
          //       { value: "Kitchen & RawMaterials Management" },
          //       { value: "Product Cost Estimation" },
          //       { value: "Chef App" },
          //       { value: "Delivery App" },
          //       { value: "Swiggy/Zomato Orders" },
          //       { value: "Orders & Delivery Management" },
          //       { value: "Purchase  & Suppliers Management" },
          //       { value: "Customer Relationship Management(CRM)" },
          //       { value: "Coupons Management" },
          //       { value: "Employees/Human Resource Management (HRM)" },
          //       { value: "Accounts Management" },
          //       { value: "Multi Variant Product Support" },
          //       { value: "Credit User Account Management" },
          //       { value: "Busienss Insights & Analytics" },
          //       { value: "Users & Roles Management" },
          //     ],
          //   },
          // },
          {
            LicenseType: "STANDARD",
            Description: "Starter",
            Supported: {
              Features: [
                { value: "Admin/POS User Access = 1" },
                { value: "Transaction Data Retention = 1 Year" },
                { value: "Cloud Hosting Plan = Standard" },
                { value: "Point Of Sale(POS) Portal" },
                { value: "Admin Portal" },
                { value: "Captain App / Tables Management" },
                { value: "Kitchen Display System(KDS)" },
                { value: "Inventory Management" },
                { value: "Dine-In, Take Away, Delivery Orders" },
                { value: "Multi-POS Sessions" },
                { value: "Barcode Generator" },
                { value: "Fuzzy Product Search" },
                { value: "AI Voice Recognition Product Search" },
                { value: "Email based OTP Authentication" },
                { value: "Keyboad & Touch friendly" },
                { value: "Advanced reports" },
                { value: "Receipe Management" },
                { value: "Kitchen & RawMaterials Management" },
                { value: "Product Cost Estimation" },
                { value: "Chef App" },
                { value: "Delivery App" },
                { value: "Swiggy/Zomato Orders" },
                { value: "Orders Management" },
                { value: "Purchase  & Suppliers Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Multi Variant Product Support" },
                { value: "Credit User Account Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
              ],
            },
            UnSupported: {
              Features: [],
            },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice",
            Supported: {
              Features: [
                { value: "Admin/POS User Access = 3" },
                { value: "Transaction Data Retention = 2 Years" },
                { value: "Cloud Hosting Plan = Professional" },
                { value: "Point Of Sale(POS) Portal" },
                { value: "Admin Portal" },
                { value: "Captain App / Tables Management" },
                { value: "Kitchen Display System(KDS)" },
                { value: "Inventory Management" },
                { value: "Dine-In, Take Away, Delivery Orders" },
                { value: "Multi-POS Sessions" },
                { value: "Barcode Generator" },
                { value: "Fuzzy Product Search" },
                { value: "AI Voice Recognition Product Search" },
                { value: "Email based OTP Authentication" },
                { value: "Keyboad & Touch friendly" },
                { value: "Advanced reports" },
                { value: "Receipe Management" },
                { value: "Kitchen & RawMaterials Management" },
                { value: "Product Cost Estimation" },
                { value: "Chef App" },
                { value: "Delivery App" },
                { value: "Swiggy/Zomato Orders" },
                { value: "Orders Management" },
                { value: "Purchase  & Suppliers Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Multi Variant Products" },
                { value: "Credit User Account Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
              ],
            },
            UnSupported: {
              Features: [],
            },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",
            Price: "Start from ₹699 / Month",
            Supported: {
              Features: [
                { value: "Admin/POS User Access = 5" },
                { value: "Transaction Data Retention = 3 Years" },
                { value: "Cloud Hosting Plan = Premium" },
                { value: "Point Of Sale(POS) Portal" },
                { value: "Admin Portal" },
                { value: "Captain App / Tables Management" },
                { value: "Kitchen Display System(KDS)" },
                { value: "Inventory Management" },
                { value: "In-Store, Take Away, Delivery Orders" },
                { value: "Multi-POS Sessions" },
                { value: "Barcode Generator" },
                { value: "Fuzzy Product Search" },
                { value: "AI Voice Recognition Product Search" },
                { value: "Email based OTP Authentication" },
                { value: "Keyboad & Touch friendly" },
                { value: "Advanced reports" },
                { value: "Receipe Management" },
                { value: "Kitchen & RawMaterials Management" },
                { value: "Product Cost Estimation" },
                { value: "Chef App" },
                { value: "Delivery App" },
                { value: "Swiggy/Zomato Orders" },
                { value: "Orders Management" },
                { value: "Purchase  & Suppliers Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Multi Variant Products" },
                { value: "Credit User Account Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
      {
        productType: this.context.ProductType.ECommerce,
        License: [
          // {
          //   LicenseType: "FREE",
          //   Description: "Basic",
          //   Supported: {
          //     Features: [
          //       { value: "Admin User Access = 1" },
          //       { value: "Transaction Data Retention 1 Year" },
          //       { value: "Transaction Fee 4.8% on Online Sale" },
          //       { value: "Advanced SEO - Disabled" },
          //       { value: "Shared Hosting" },
          //       { value: "Auto Scaling - Enabled" },
          //       { value: "Unlimited Products" },
          //       { value: "UnLimited Customer Access" },
          //       { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
          //       { value: "Wishlist, Vlogs & Blogs" },
          //       { value: "Single & Multi Varient Products support" },
          //       { value: "2-Factor Authentication (SMS/Email based)" },
          //       { value: "Free SSL and Custom domain" },
          //       { value: "Inventory & Stock Management" },
          //       { value: "Basic Reports" },
          //       { value: "Standard Themes" },
          //       { value: "Orders, Packaging and Shipping Management" },
          //       { value: "Tax and Delivery Management" },
          //       { value: "Uploading Videos to Product - Unsupported" },
          //       { value: "Multiple Images for a Product - Unsupported" },
          //       { value: "Purchase Management" },
          //       { value: "Customer Relationship Management(CRM)" },
          //       { value: "Coupons Management" },
          //       { value: "Employees/Human Resource Management (HRM)" },
          //       { value: "Accounts Management" },
          //       { value: "Busienss Insights & Analytics" },
          //       { value: "Users & Roles Management" },
          //       { value: "WhatApp Integration - On Demand" },
          //       { value: "SMS based Order Notification- On Demand" },
          //       { value: "GenAI based Customer Chatbot - On Demand " },
          //     ],
          //   },
          //   UnSupported: {
          //     Features: [],
          //   },
          // },
          {
            LicenseType: "STANDARD",
            Description: "Starter",
            Supported: {
              Features: [
                { value: "Admin User Access = 1" },
                { value: "Transaction Data Retention 1 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Advanced SEO - Disabled" },
                { value: "Shared Hosting" },
                { value: "Auto Scaling - Enabled" },
                { value: "Unlimited Products" },
                { value: "UnLimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Wishlist" },
                { value: "Single & Multi Varient Products support" },
                { value: "2-Factor Authentication (SMS/Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Advanced reports" },
                { value: "Standard & Custom Themes" },
                { value: "Orders, Packaging and Shipping Management" },
                { value: "Tax and Delivery Management" },
                { value: "Uploading Videos to Product - Unsupported" },
                { value: "Multiple Images for a Product - Unsupported" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: {
              Features: [],
            },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice",
            Supported: {
              Features: [
                { value: "Admin User Access = 3" },
                { value: "Transaction Data Retention 2 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Advanced SEO - Disabled" },
                { value: "Shared Hosting" },
                { value: "Auto Scaling - Enabled" },
                { value: "Unlimited Products" },
                { value: "UnLimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Wishlist" },
                { value: "Single & Multi Varient Products support" },
                { value: "2-Factor Authentication (SMS/Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Advanced reports" },
                { value: "Standard & Custom Themes" },
                { value: "Orders, Packaging and Shipping Management" },
                { value: "Tax and Delivery Management" },
                { value: "Uploading Videos to Product - Supported" },
                { value: "Multiple Images for a Product - Supported" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: {
              Features: [],
            },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",
            Supported: {
              Features: [
                { value: "Admin User Access = 5" },
                { value: "Transaction Data Retention 3 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Advanced SEO - Enabled" },
                { value: "Independent Cloud Hosting" },
                { value: "Auto Scaling - Enabled" },
                { value: "Unlimited Products" },
                { value: "Support upto UnLimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Wishlist" },
                { value: "Single & Multi Varient Products support" },
                { value: "2-Factor Authentication (SMS/Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Advanced reports" },
                { value: "Standard & Custom Themes" },
                { value: "Orders, Packaging and Shipping Management" },
                { value: "Tax and Delivery Management" },
                { value: "Uploading Videos to Product - Supported" },
                { value: "Multiple Images for a Product - Supported" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
      {
        productType: this.context.ProductType.ECommerce_B2C_Restaurant,
        License: [
          // {
          //   LicenseType: "FREE",
          //   Description: "Basic",
          //   Supported: {
          //     Features: [
          //       { value: "Admin User Access = 1" },
          //       { value: "Transaction Data Retention 1 Year" },
          //       { value: "Transaction Fee 4.8% on Online Sale" },
          //       { value: "Advanced SEO - Disabled" },
          //       { value: "Shared Hosting" },
          //       { value: "Auto Scaling - Enabled" },
          //       { value: "Unlimited Products" },
          //       { value: "UnLimited Customer Access" },
          //       { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
          //       { value: "Wishlist, Vlogs & Blogs" },
          //       { value: "Single & Multi Varient Products support" },
          //       { value: "2-Factor Authentication (SMS/Email based)" },
          //       { value: "Free SSL and Custom domain" },
          //       { value: "Inventory & Stock Management" },
          //       { value: "Basic Reports" },
          //       { value: "Standard Themes" },
          //       { value: "Orders, Packaging and Shipping Management" },
          //       { value: "Tax and Delivery Management" },
          //       { value: "Uploading Videos to Product - Unsupported" },
          //       { value: "Multiple Images for a Product - Unsupported" },
          //       { value: "Purchase Management" },
          //       { value: "Customer Relationship Management(CRM)" },
          //       { value: "Coupons Management" },
          //       { value: "Employees/Human Resource Management (HRM)" },
          //       { value: "Accounts Management" },
          //       { value: "Busienss Insights & Analytics" },
          //       { value: "Users & Roles Management" },
          //       { value: "WhatApp Integration - On Demand" },
          //       { value: "SMS based Order Notification- On Demand" },
          //       { value: "GenAI based Customer Chatbot - On Demand " },
          //     ],
          //   },
          //   UnSupported: {
          //     Features: [],
          //   },
          // },
          {
            LicenseType: "STANDARD",
            Description: "Starter",
            Supported: {
              Features: [
                { value: "Admin User Access = 1" },
                { value: "Transaction Data Retention 1 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Advanced SEO - Disabled" },
                { value: "Shared Hosting" },
                { value: "Auto Scaling - Enabled" },
                { value: "Unlimited Products" },
                { value: "UnLimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Wishlist" },
                { value: "Single & Multi Varient Products support" },
                { value: "2-Factor Authentication (SMS/Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Advanced reports" },
                { value: "Standard & Custom Themes" },
                { value: "Orders, Packaging and Shipping Management" },
                { value: "Tax and Delivery Management" },
                { value: "Uploading Videos to Product - Unsupported" },
                { value: "Multiple Images for a Product - Unsupported" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: {
              Features: [],
            },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice",
            Supported: {
              Features: [
                { value: "Admin User Access = 3" },
                { value: "Transaction Data Retention 2 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Advanced SEO - Disabled" },
                { value: "Shared Hosting" },
                { value: "Auto Scaling - Enabled" },
                { value: "Unlimited Products" },
                { value: "UnLimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Wishlist" },
                { value: "Single & Multi Varient Products support" },
                { value: "2-Factor Authentication (SMS/Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Advanced reports" },
                { value: "Standard & Custom Themes" },
                { value: "Orders, Packaging and Shipping Management" },
                { value: "Tax and Delivery Management" },
                { value: "Uploading Videos to Product - Supported" },
                { value: "Multiple Images for a Product - Supported" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: {
              Features: [],
            },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",
            Supported: {
              Features: [
                { value: "Admin User Access = 5" },
                { value: "Transaction Data Retention 3 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Advanced SEO - Enabled" },
                { value: "Independent Cloud Hosting" },
                { value: "Auto Scaling - Enabled" },
                { value: "Unlimited Products" },
                { value: "Support upto UnLimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Wishlist" },
                { value: "Single & Multi Varient Products support" },
                { value: "2-Factor Authentication (SMS/Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Advanced reports" },
                { value: "Standard & Custom Themes" },
                { value: "Orders, Packaging and Shipping Management" },
                { value: "Tax and Delivery Management" },
                { value: "Uploading Videos to Product - Supported" },
                { value: "Multiple Images for a Product - Supported" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
      {
        productType: this.context.ProductType.ECommerce_B2B,
        License: [
          // {
          //   LicenseType: "FREE",
          //   Description: "Basic",
          //   Supported: {
          //     Features: [
          //       { value: "Admin User Access = 1" },
          //       { value: "Transaction Data Retention 1 Year" },
          //       { value: "Transaction Fee 4.8% on Online Sale" },
          //       { value: "Advanced SEO - Unsupported" },
          //       { value: "Shared Cloud Hosting" },
          //       { value: "Auto Scaling - Enabled" },
          //       { value: "Unlimited Products" },
          //       { value: "Unlimited Customer Access" },
          //       { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
          //       { value: "Wishlist, Vlogs & Blogs" },
          //       { value: "Single & Multi Varient Products support" },
          //       { value: "2-Factor Authentication (SMS/Email based)" },
          //       { value: "Free SSL and Custom domain" },
          //       { value: "Inventory & Stock Management" },
          //       { value: "Standard Themes" },
          //       { value: "Leads Management" },
          //       { value: "Quotation Management" },
          //       { value: "Orders & Delivery Management" },
          //       { value: "Tax and Delivery Management" },
          //       { value: "Single & Multi Variant Products" },
          //       { value: "Basic reports" },
          //       { value: "Products Videos " },
          //       { value: "Setting Multiple Images for a Product" },
          //       { value: "Packaging Management" },
          //       { value: "Product Purchase Management" },
          //       { value: "Customer Relationship Management(CRM)" },
          //       { value: "Coupons Management" },
          //       { value: "Human Resource Management (HRM)" },
          //       { value: "Accounts Management" },
          //       { value: "Busienss Insights & Analytics" },
          //       { value: "Users & Roles Management" },
          //       { value: "WhatApp Integration - On Demand" },
          //       { value: "SMS based Order Notification- On Demand" },
          //       { value: "GenAI based Customer Chatbot - On Demand " },
          //     ],
          //   },
          //   UnSupported: {
          //     Features: [],
          //   },
          // },
          {
            LicenseType: "STANDARD",
            Description: "Starter",
            Supported: {
              Features: [
                { value: "Admin User Access = 1" },
                { value: "Transaction Data Retention 1 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Advanced SEO - Unsupported" },
                { value: "Shared Cloud Hosting" },
                { value: "Auto Scaling - Enabled" },
                { value: "Unlimited Products" },
                { value: "Unlimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Wishlist" },
                { value: "Single & Multi Varient Products support" },
                { value: "2-Factor Authentication (SMS/Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Standard & Custom Themes" },
                { value: "Customer Leads Management" },
                { value: "Quotation Management" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Single & Multi Variant Products" },
                { value: "Advanced reports" },
                { value: "Products Videos " },
                { value: "Setting Multiple Images for a Product" },
                { value: "Packaging Management" },
                { value: "Product Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: {
              Features: [],
            },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice",
            Supported: {
              Features: [
                { value: "Admin User Access = 3" },
                { value: "Transaction Data Retention 2 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Advanced SEO - Unsupported" },
                { value: "Shared Cloud Hosting" },
                { value: "Auto Scaling - Enabled" },
                { value: "Unlimited Products" },
                { value: "Unlimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Wishlist" },
                { value: "Single & Multi Varient Products support" },
                { value: "2-Factor Authentication (SMS/Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Standard & Custom Themes" },
                { value: "Customer Leads Management" },
                { value: "Quotation Management" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Single & Multi Variant Products" },
                { value: "Advanced reports" },
                { value: "Products Videos " },
                { value: "Setting Multiple Images for a Product" },
                { value: "Packaging Management" },
                { value: "Product Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: {
              Features: [],
            },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",
            Supported: {
              Features: [
                { value: "Admin User Access = 5" },
                { value: "Transaction Data Retention 3 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Advanced SEO - Supported" },
                { value: "Independent Cloud Hosting" },
                { value: "Auto Scaling - Enabled" },
                { value: "Unlimited Products" },
                { value: "Unlimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Wishlist" },
                { value: "Single & Multi Varient Products support" },
                { value: "2-Factor Authentication (SMS/Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Standard & Custom Themes" },
                { value: "Customer Leads Management" },
                { value: "Quotation Management" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Single & Multi Variant Products" },
                { value: "Advanced reports" },
                { value: "Products Videos " },
                { value: "Setting Multiple Images for a Product" },
                { value: "Packaging Management" },
                { value: "Product Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
      {
        productType: this.context.ProductType.KIOSK_ECommerce,
        License: [
          // {
          //   LicenseType: "FREE",
          //   Description: "Starter",

          //   Supported: {
          //     Features: [
          //       { value: "Admin users = 1" },
          //       { value: "Transaction Data Retention upto 7 Days" },
          //       { value: "Unlimited Products" },
          //       { value: "Unlimited Customer Access" },
          //       { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
          //       { value: "Single & Multiple Product Varient" },
          //       { value: "Email Authentication" },
          //       { value: "Free SSL and Custom domain" },
          //       { value: "Inventory & Stock Management" },
          //       { value: "Basic reports" },
          //       { value: "Standard Themes" },
          //       { value: "Orders Management" },
          //       { value: "Tax and Delivery Management" },
          //     ],
          //   },
          //   UnSupported: {
          //     Features: [
          //       { value: "Multiple Image support on Product Catalog" },
          //       { value: "Packaging Management" },
          //       { value: "Customer Relationship Management(CRM)" },
          //       { value: "Coupons Management" },
          //       { value: "Delivery Management" },
          //       { value: "Busienss Insights & Analytics" },
          //       { value: "Users & Roles Management" },
          //       { value: "WhatApp Integration - On Demand" },
          //       { value: "SMS based Order Notification- On Demand" },
          //     ],
          //   },
          // },
          {
            LicenseType: "STANDARD",
            Description: "Starter!",

            Supported: {
              Features: [
                { value: "Admin users = 1" },
                { value: "Transaction Data Retention upto 1 Year" },
                { value: "Unlimited Products" },
                { value: "Unlimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Single & Multiple Product Varient" },
                { value: "Email Authentication" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Standard Themes" },
                { value: "Orders Management" },
                { value: "Tax and Delivery Management" },
                { value: "Multiple Image support on Product Catalog" },
                { value: "Packaging Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice!",

            Supported: {
              Features: [
                { value: "Admin users = 3" },
                { value: "Transaction Data Retention upto 2 Year" },
                { value: "Unlimited Products" },
                { value: "Unlimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Single & Multiple Product Varient" },
                { value: "Email Authentication" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Standard Themes" },
                { value: "Orders Management" },
                { value: "Tax and Delivery Management" },
                { value: "Multiple Image support on Product Catalog" },
                { value: "Packaging Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",
            Supported: {
              Features: [
                { value: "Admin users = 5" },
                { value: "Transaction Data Retention upto 3 Year" },
                { value: "Unlimited Products" },
                { value: "Unlimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Single & Multiple Product Varient" },
                { value: "Email Authentication" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Standard Themes" },
                { value: "Orders Management" },
                { value: "Tax and Delivery Management" },
                { value: "Multiple Image support on Product Catalog" },
                { value: "Packaging Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
      {
        productType: this.context.ProductType.QRCODE_ECommerce,
        License: [
          // {
          //   LicenseType: "FREE",
          //   Description: "Starter",

          //   Supported: {
          //     Features: [
          //       { value: "Admin users = 1" },
          //       { value: "Transaction Data Retention upto 7 Days" },
          //       { value: "Unlimited Products" },
          //       { value: "Unlimited Customer Access" },
          //       { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
          //       { value: "Single & Multiple Product Varient" },
          //       { value: "Email Authentication" },
          //       { value: "Free SSL and Custom domain" },
          //       { value: "Inventory & Stock Management" },
          //       { value: "Basic reports" },
          //       { value: "Standard Themes" },
          //       { value: "Orders Management" },
          //       { value: "Tax and Delivery Management" },
          //     ],
          //   },
          //   UnSupported: {
          //     Features: [
          //       { value: "Multiple Image support on Product Catalog" },
          //       { value: "Packaging Management" },
          //       { value: "Customer Relationship Management(CRM)" },
          //       { value: "Coupons Management" },
          //       { value: "Delivery Management" },
          //       { value: "Busienss Insights & Analytics" },
          //       { value: "Users & Roles Management" },
          //       { value: "WhatApp Integration - On Demand" },
          //       { value: "SMS based Order Notification- On Demand" },
          //     ],
          //   },
          // },
          {
            LicenseType: "STANDARD",
            Description: "Starter!",

            Supported: {
              Features: [
                { value: "Admin users = 1" },
                { value: "Transaction Data Retention upto 1 Year" },
                { value: "Unlimited Products" },
                { value: "Unlimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Single & Multiple Product Varient" },
                { value: "Email Authentication" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Standard Themes" },
                { value: "Orders Management" },
                { value: "Tax and Delivery Management" },
                { value: "Multiple Image support on Product Catalog" },
                { value: "Packaging Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice!",

            Supported: {
              Features: [
                { value: "Admin users = 3" },
                { value: "Transaction Data Retention upto 2 Year" },
                { value: "Unlimited Products" },
                { value: "Unlimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Single & Multiple Product Varient" },
                { value: "Email Authentication" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Standard Themes" },
                { value: "Orders Management" },
                { value: "Tax and Delivery Management" },
                { value: "Multiple Image support on Product Catalog" },
                { value: "Packaging Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",
            Supported: {
              Features: [
                { value: "Admin users = 5" },
                { value: "Transaction Data Retention upto 3 Year" },
                { value: "Unlimited Products" },
                { value: "Unlimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Single & Multiple Product Varient" },
                { value: "Email Authentication" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Standard Themes" },
                { value: "Orders Management" },
                { value: "Tax and Delivery Management" },
                { value: "Multiple Image support on Product Catalog" },
                { value: "Packaging Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
      {
        productType: this.context.ProductType.Retail_ERP,
        License: [
          {
            LicenseType: "STANDARD",
            Description: "Starter",
            Supported: {
              Features: [
                { value: "Admin User Access = 1" },
                { value: "Transaction Data Retention 1 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point Of Sale Portal" },
                { value: "Online Shop/Ecommerce Portal" },
                { value: "Advanced SEO - Unsupported" },
                { value: "Shared Cloud Hosting" },
                { value: "Auto Scaling - Enabled" },
                { value: "Unlimited Products" },
                { value: "UnLimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Wishlist, Vlogs & Blogs" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stocks Management" },
                { value: "Basic reports" },
                { value: "Orders Management" },
                { value: "Tax and Delivery Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice",
            Supported: {
              Features: [
                { value: "Admin User Access = 3" },
                { value: "Transaction Data Retention 2 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point Of Sale Portal" },
                { value: "Online Shop/Ecommerce Portal" },
                { value: "Advanced SEO - Unsupported" },
                { value: "Shared Cloud Hosting" },
                { value: "Auto Scaling - Enabled" },
                { value: "Unlimited Products" },
                { value: "UnLimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Wishlist, Vlogs & Blogs" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stocks Management" },
                { value: "Basic reports" },
                { value: "Orders Management" },
                { value: "Tax and Delivery Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",
            Price: "Start from ₹699 / Month",
            Supported: {
              Features: [
                { value: "Admin User Access = 5" },
                { value: "Transaction Data Retention 3 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point Of Sale Portal" },
                { value: "Online Shop/Ecommerce Portal" },
                { value: "Advanced SEO - Unsupported" },
                { value: "Shared Cloud Hosting" },
                { value: "Auto Scaling - Enabled" },
                { value: "Unlimited Products" },
                { value: "UnLimited Customer Access" },
                { value: "Payment Gateway RazorPay, COD, Manual UPI, GPAY" },
                { value: "Wishlist, Vlogs & Blogs" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stocks Management" },
                { value: "Basic reports" },
                { value: "Orders Management" },
                { value: "Tax and Delivery Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
      {
        productType: this.context.ProductType.Restaurant_ERP,
        License: [
          {
            LicenseType: "STANDARD",
            Description: "Starter",

            Supported: {
              Features: [
                { value: "Admin User Access = 1" },
                { value: "Transaction Data Retention 1 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Multi POS Session" },
                { value: "Dine-in/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (SMS based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory Management" },
                { value: "Advanced Reports" },
                { value: "Custom Themes On Online Store" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Captain App" },
                { value: "Kitchen Display System(KDS)" },
                { value: "Receipe Management" },
                { value: "Kitchen & RawMaterials Management" },
                { value: "Chef App" },
                { value: "Delivery App" },
                { value: "Swiggy/Zomato Orders" },
                { value: "Product Videos " },
                { value: "Multiple Image support on Product Catalog" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice",

            Supported: {
              Features: [
                { value: "Admin User Access = 3" },
                { value: "Transaction Data Retention 2 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Multi POS Session" },
                { value: "Dine-in/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (SMS based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory Management" },
                { value: "Advanced Reports" },
                { value: "Custom Themes On Online Store" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Captain App" },
                { value: "Kitchen Display System(KDS)" },
                { value: "Receipe Management" },
                { value: "Kitchen & RawMaterials Management" },
                { value: "Chef App" },
                { value: "Delivery App" },
                { value: "Swiggy/Zomato Orders" },
                { value: "Product Videos " },
                { value: "Multiple Image support on Product Catalog" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",
            Price: "Start from ₹699 / Month",
            Supported: {
              Features: [
                { value: "Admin User Access = 5" },
                { value: "Transaction Data Retention 3 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Multi POS Session" },
                { value: "Dine-in/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (SMS based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory Management" },
                { value: "Advanced Reports" },
                { value: "Custom Themes On Online Store" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Captain App" },
                { value: "Kitchen Display System(KDS)" },
                { value: "Receipe Management" },
                { value: "Kitchen & RawMaterials Management" },
                { value: "Chef App" },
                { value: "Delivery App" },
                { value: "Swiggy/Zomato Orders" },
                { value: "Product Videos " },
                { value: "Multiple Image support on Product Catalog" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
      {
        productType: this.context.ProductType.ERP,
        License: [
          {
            LicenseType: "STANDARD",
            Description: "Starter",
            Supported: {
              Features: [
                { value: "Admin User Access = 1" },
                { value: "Transaction Data Retention 1 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice",
            Supported: {
              Features: [
                { value: "Admin User Access = 3" },
                { value: "Transaction Data Retention 2 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",

            Supported: {
              Features: [
                { value: "Admin User Access = 5" },
                { value: "Transaction Data Retention 3 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
      {
        productType: this.context.ProductType.SupplyChain,
        License: [
          {
            LicenseType: "STANDARD",
            Description: "Starter",
            Supported: {
              Features: [
                { value: "Admin User Access = 1" },
                { value: "Transaction Data Retention 1 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice",
            Supported: {
              Features: [
                { value: "Admin User Access = 3" },
                { value: "Transaction Data Retention 2 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",

            Supported: {
              Features: [
                { value: "Admin User Access = 5" },
                { value: "Transaction Data Retention 3 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
      {
        productType: "12",
        productTypeName: "WarehouseManagement",
        Title: "Inventory & Warehouse Management Solution(WMS)",
        License: [
          {
            LicenseType: "STANDARD",
            Description: "Starter",
            Supported: {
              Features: [
                { value: "Admin User Access = 1" },
                { value: "Transaction Data Retention 1 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice",
            Supported: {
              Features: [
                { value: "Admin User Access = 3" },
                { value: "Transaction Data Retention 2 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",

            Supported: {
              Features: [
                { value: "Admin User Access = 5" },
                { value: "Transaction Data Retention 3 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
      {
        productType: "13",
        productTypeName: "ProductionManagement",
        Title: "Production(workflow) Management System(PMS)",
        License: [
          {
            LicenseType: "STANDARD",
            Description: "Starter",
            Supported: {
              Features: [
                { value: "Admin User Access = 1" },
                { value: "Transaction Data Retention 1 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice",
            Supported: {
              Features: [
                { value: "Admin User Access = 3" },
                { value: "Transaction Data Retention 2 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",

            Supported: {
              Features: [
                { value: "Admin User Access = 5" },
                { value: "Transaction Data Retention 3 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },

      {
        productType: "15",
        productTypeName: "CRM",
        Title: "Customer Relationship Management(CRM) System",
        License: [
          {
            LicenseType: "STANDARD",
            Description: "Starter",
            Supported: {
              Features: [
                { value: "Admin User Access = 1" },
                { value: "Transaction Data Retention 1 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice",
            Supported: {
              Features: [
                { value: "Admin User Access = 3" },
                { value: "Transaction Data Retention 2 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",

            Supported: {
              Features: [
                { value: "Admin User Access = 5" },
                { value: "Transaction Data Retention 3 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
      {
        productType: "16",
        productTypeName: "HRM",
        Title: "Employees or Humun Resource Management (HRM) System",
        License: [
          {
            LicenseType: "STANDARD",
            Description: "Starter",
            Supported: {
              Features: [
                { value: "Admin User Access = 1" },
                { value: "Transaction Data Retention 1 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice",
            Supported: {
              Features: [
                { value: "Admin User Access = 3" },
                { value: "Transaction Data Retention 2 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",

            Supported: {
              Features: [
                { value: "Admin User Access = 5" },
                { value: "Transaction Data Retention 3 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
      {
        productType: "17",
        productTypeName: "Finance",
        Title: "Accounts & Payroll Management System (AMS)",
        License: [
          {
            LicenseType: "STANDARD",
            Description: "Starter",
            Supported: {
              Features: [
                { value: "Admin User Access = 1" },
                { value: "Transaction Data Retention 1 Year" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PROFESSIONAL",
            Description: "Best Choice",
            Supported: {
              Features: [
                { value: "Admin User Access = 3" },
                { value: "Transaction Data Retention 2 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
          {
            LicenseType: "PREMIUM",
            Description: "Way to go!",

            Supported: {
              Features: [
                { value: "Admin User Access = 5" },
                { value: "Transaction Data Retention 3 Years" },
                { value: "Transaction Fee 1.5% on Online Sale" },
                { value: "Point-Of-Sale Portal" },
                { value: "Admin Portal" },
                { value: "ECommerce Portal / Online Shop" },
                { value: "Single POS Session" },
                { value: "InStore/TakeAway/Home Delivery Orders on POS" },
                { value: "Payment Mode: Cash-On-Delivery, Manual UPI" },
                { value: "Wishlist, Vlogs & Blogs on Online Store" },
                { value: "2-Factor Authentication (Email based)" },
                { value: "Free SSL and Custom domain" },
                { value: "Inventory & Stock Management" },
                { value: "Basic reports" },
                { value: "Custom Themes on Ecommerce" },
                { value: "Orders & Delivery Management" },
                { value: "Tax and Delivery Management" },
                { value: "Raw Materials Inventory Management" },
                { value: "Production Workflow Management" },
                { value: "Packaging Management" },
                { value: "Purchase Management" },
                { value: "Customer Relationship Management(CRM)" },
                { value: "Coupons Management" },
                { value: "Leads Management" },
                { value: "Employees/Human Resource Management (HRM)" },
                { value: "Accounts Management" },
                { value: "Delivery Management" },
                { value: "Busienss Insights & Analytics" },
                { value: "Users & Roles Management" },
                { value: "WhatApp Integration - On Demand" },
                { value: "SMS based Order Notification- On Demand" },
                { value: "GenAI based Customer Chatbot - On Demand " },
              ],
            },
            UnSupported: { Features: [] },
          },
        ],
      },
    ];
    this.setState({ products: prods });
  };

  SetSelectProductFeatures = () => {
    var product = this.state.products.filter(
      (f) => f.productType == this.state.productType
    );
    if (product.length > 0) {
      var result = this.context.prods.filter(
        (f) => f.productType == this.state.productType
      );
      this.context.SetSelectedProduct(result[0]);

      this.setState({ selectedProduct: product[0] });
    } else this.setState({ selectedProduct: "" });
  };

  GetProductDescription = () => {
    var result = this.context.prods.filter(
      (f) => f.productType == this.state.selectedProduct.productType
    );
    if (result.length > 0) return result[0].shortDescription;
    return "NA";
  };

  GetProductObject = () => {
    var result = this.context.prods.filter(
      (f) => f.productType == this.state.selectedProduct.productType
    );
    if (result.length > 0) return result[0];
    return {};
  };
  GetLicenseTypeIdFromName = (licenseType) => {
    if (licenseType == "FREE") return this.context.LicenseType.FREE;
    if (licenseType == "STANDARD") return this.context.LicenseType.STANDARD;
    if (licenseType == "PROFESSIONAL")
      return this.context.LicenseType.PROFESSIONAL;
    if (licenseType == "PREMIUM") return this.context.LicenseType.PREMIUM;
  };

  componentDidMount() {
    this.InitProducts();
  }

  render() {
    return (
      <>
        {/* Pricing Plan Start  */}
        <div class="" style={{ paddingBottom: "200px" }}>
          <div className="p-1" style={{ margin: "20px" }}>
            <div class="border-start border-5 border-primary ps-2 mb-2">
              {/* <h6 class="text-primary text-uppercase">Index</h6> */}
              <h2 class="display-5  mb-0">Pricing</h2>
            </div>
            <br />
            <br />
            <div className="container">
              <Row>
                <Col md={2}>
                  <h4 className="text-primary text-start">Select Product:</h4>
                </Col>
                <Col md={10} className="text-start">
                  <Form.Select
                    type="text"
                    name="productType"
                    className="bg-white text-primary fw-bold"
                    style={{ fontSize: "22px" }}
                    required
                    value={this.state.productType}
                    onChange={(e) => {
                      this.setState(
                        {
                          productType: e.target.value,
                        },
                        () => {
                          this.SetSelectProductFeatures();
                        }
                      );
                    }}
                  >
                    <option value=""></option>
                    {this.context.prods
                      .sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1))
                      .map((m) => (
                        <>
                          <option value={m.productType}>{m.name}</option>
                        </>
                      ))}
                  </Form.Select>
                </Col>
              </Row>
            </div>
            {this.state.selectedProduct != "" ? (
              <>
                <div className="my-5 px-3 border CornersRoundedMedium bg-light">
                  <Row className="text-center my-2 mx-0 ">
                    {/* <Col xs={2}>
                    
                  </Col> */}
                    <Col xs={12}>
                      <h2 class=" mb-0 ">{this.GetProductObject().name}</h2>
                      <img
                        className="my-0 border-0 py-2 w-100 CornersRoundedMedium"
                        variant="top"
                        src={
                          this.context.GetEcSettingValueByName(
                            "StorageBlobImageUrl"
                          ) + `${this.GetProductObject().imgFileName}`
                        }
                        height="200"
                        style={{ objectFit: "contain" }}
                      />
                      <h5 class="text-primary mb-0">
                        {this.GetProductObject().shortDescription}
                      </h5>
                      <span>{this.GetProductObject().description}</span>
                    </Col>
                  </Row>
                  <div class="row g-2 text-center justify-content-center ">
                    {this.state.selectedProduct.License.map((license) => (
                      <>
                        <div class="col-lg-3 border bg-light mx-0">
                          <div className="bg-primary text-white py-2">
                            <h3 class="text-white">{license.LicenseType}</h3>
                            <h6 class="mb-2">{license.Description}</h6>
                          </div>
                          <div class="text-start p-0 mb-0 bg-light text-black">
                            <h4 class="text-center">
                              ₹
                              {this.context.GetPriceOfSelectedProductByLicenseType(
                                this.GetLicenseTypeIdFromName(
                                  license.LicenseType
                                )
                              )}{" "}
                              / Month
                            </h4>

                            <div className="px-5 py-3 text-center">
                              <Button
                                as={Link}
                                className=" CornersRounded border border-dark"
                                variant="secondary"
                                to="/Checkout"
                                onClick={(e) => {
                                  if (
                                    this.context.userData.loginStatus !=
                                    "active"
                                  ) {
                                    this.context.ShowUserLoginNew(true);
                                  }
                                  var selectedProduct =
                                    this.context.prods.filter(
                                      (f) =>
                                        f.productType ==
                                        this.state.selectedProduct.productType
                                    )[0];
                                  this.context.SetSelectedProduct(
                                    selectedProduct
                                  );
                                }}
                              >
                                {license.LicenseType == "FREE" ? (
                                  <>&nbsp;&nbsp;Start Now! &nbsp;&nbsp;</>
                                ) : (
                                  <>&nbsp;&nbsp;Buy Now! &nbsp;&nbsp;</>
                                )}

                                {/* <i class="bi bi-arrow-right fs-4 text-primary"></i> &nbsp; */}
                              </Button>
                            </div>
                            <ul style={{ listStyleType: "none" }}>
                              {license.Supported.Features.map((supported) => (
                                <>
                                  <li>
                                    <i class="bi bi-check-square fs-4 text-primary"></i>
                                    &nbsp;
                                    {supported.value}
                                  </li>
                                </>
                              ))}
                              {license.UnSupported.Features.map(
                                (unsupported) => (
                                  <>
                                    <li>
                                      <i class="bi bi-x-square fs-4 text-dark"></i>{" "}
                                      &nbsp;
                                      {unsupported.value}
                                    </li>
                                  </>
                                )
                              )}
                            </ul>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </>
    );
  }
}
